<div class="card p-3 d-flex flex-column gap-3 mt-2" style="min-height: 600px !important">
  <div class="d-flex align-items-center">
    <Button
      style="border: none; background-color: transparent"
      (click)="back()"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
        alt=""
        width="40px"
      />
    </Button>
    <span
      class="text-black"
      style="font-size: 20px; font-weight: 500; margin-left: 15px"
      >Pickup</span
    >
  </div>
  <nz-skeleton
    [ngClass]="loading ? 'mt-4' : 'mt-0'"
    [nzLoading]="loading"
    [nzActive]="true"
  >
    <div class="d-flex flex-column gap-3 mt-2">
      <div class="d-flex">
        <span class="col-3">Address</span>
        <div class="col-5 border rounded p-2 d-flex gap-1">
          {{ address }}
        </div>
      </div>
      <div class="d-flex">
        <span class="col-3">Pickup Method</span>
        <div class="col-5 border rounded p-2 d-flex gap-1">
          {{ pickupMethod }}
        </div>
      </div>
      <div class="d-flex">
        <span class="col-3">Expedition</span>
        <div class="col-5 border rounded p-2 d-flex gap-1">
          <img [src]="expedition" alt="expedition" width="100px">
        </div>
      </div>
      <div class="d-flex">
        <span class="col-3">Vehicle</span>
        <div class="col-5">
          <img src="https://storage.googleapis.com/komerce/assets/svg/motor-border.svg" alt="vehicle">
        </div>
      </div>
      <span class="col-3">Product</span>
      <div class="mt-2">
        <div *ngFor="let item of detailOrder; let i = index">
          <div class="d-flex justify-content-between">
            <div class="d-flex gap-3 col-6">
              <div class="d-flex flex-column">
                <span>{{ item.product_name }}</span>
                <small>{{ item.product_variant_name }}</small>
              </div>
            </div>
            <div class="d-flex flex-column col-3">
              <span>X{{ item.qty }}</span>
              <small>{{ item.product_weight }} grams</small>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </div>
    <div
      class="shadow-lg bg-white d-flex align-items-center justify-content-end gap-2 px-4 py-2 mt-5 fixed-bottom"
      style="z-index: 0 !important; height: 60px"
      *ngIf="shipping === 'GOSEND' || shipping === 'gosend'"
    >
      <button class="btn btn-outline-primary" style="width: 100px" (click)="cancelRequest()">
        Cancel
      </button>
      <button
        class="btn btn-primary text-white"
        style="width: auto; margin-right: 100px"
        (click)="submitRequest()"
      >
        Request Pickup
      </button>
    </div>
  </nz-skeleton>
</div>
